import type { InputError } from "~/types/common.types";
import Error from "../form/Error";
import InputLabel from "./InputLabel";

type Props = {
  value?: string | number | undefined;
  setValue: (input: string | number) => void;
  error?: InputError;
  label?: string;
  required?: boolean;
  disabled?: boolean;
  placeholder?: string;
  type?: string;
  ["data-cy"]?: string;
};

const TextInput = ({
  value,
  setValue,
  error,
  label,
  required,
  disabled,
  placeholder,
  type,
  ...props
}: Props) => {
  return (
    <div>
      {label && (
        <InputLabel uneditable={disabled} label={label} required={required} />
      )}
      <div className="flex items-center justify-between gap-3 rounded-md bg-surface px-3 py-2 shadow-md">
        <div className="w-full border-none text-end">
          <input
            className="w-full border-none bg-transparent focus:outline-none dark:text-[#d2d2dc]"
            value={value || ""}
            type={type}
            onChange={(event) => {
              if (error) {
                const newErrors = { ...error.allErrors };
                delete newErrors[error.name];
                error.setErrors(newErrors);
              }
              setValue(event.target.value);
            }}
            disabled={disabled}
            placeholder={placeholder}
            data-cy={props["data-cy"]}
          />
        </div>
      </div>
      {error && <Error error={error.message} />}
    </div>
  );
};

export default TextInput;
